import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Plus } from "lucide-react";

/**
 * Large, tap-friendly module card for the employee home screen.
 * Shows an icon, a live count, a title, a short description and one clear action.
 * Optional secondary CTA (e.g. "Neue Bestellung") rendered as a filled button.
 */
export const HomeCard = ({ to, title, description, count, countLabel, icon: Icon, testid, secondaryLabel, secondaryTo }) => {
  const navigate = useNavigate();
  return (
    <Link
      to={to}
      data-testid={testid}
      className="group relative flex flex-col justify-between bg-[var(--surface)] border border-[var(--border)] rounded-2xl p-6 card-hover"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="h-12 w-12 rounded-xl flex items-center justify-center bg-[var(--surface-alt)] text-[var(--pop-pink)] transition-transform group-hover:scale-110">
          <Icon size={24} strokeWidth={2} />
        </div>
        {count != null && (
          <div className="text-right">
            <div className="font-mono font-black text-3xl leading-none text-[var(--text)]" data-testid={`${testid}-count`}>
              {count}
            </div>
            {countLabel && <div className="overline mt-1">{countLabel}</div>}
          </div>
        )}
      </div>

      <div className="mt-5">
        <h3 className="font-display font-bold text-lg text-[var(--text)] group-hover:text-[var(--pop-pink)] transition-colors">
          {title}
        </h3>
        <p className="text-sm text-[var(--text-muted)] mt-1 leading-snug">{description}</p>
      </div>

      <div className="mt-5 pt-4 border-t border-[var(--border)] flex items-center justify-between gap-2">
        <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--pop-pink)]">
          Öffnen
          <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
        </span>
        {secondaryTo && (
          <button
            type="button"
            data-testid={`${testid}-secondary`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); navigate(secondaryTo); }}
            className="inline-flex items-center gap-1 rounded-full bg-[var(--pop-pink)] text-white px-3 h-8 text-xs font-bold hover:opacity-90 transition-opacity"
          >
            <Plus size={14} /> {secondaryLabel}
          </button>
        )}
      </div>
    </Link>
  );
};

export default HomeCard;
